import React, { useState } from "react";
import { postContact } from "../API/API";
import "../styles/ContactUs.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    message: "",
    file: null,
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "file") {
      setFormData((prev) => ({ ...prev, file: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("first_name", formData.first_name);
    data.append("last_name", formData.last_name);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("message", formData.message);
    if (formData.file) {
      data.append("file", formData.file);
    }

    try {
      const response = await postContact(data);
      console.log("Contact form submitted:", response.data);
      setStatus("Message sent successfully!");
      setFormData({ first_name: "", last_name: "", email: "", phone: "", message: "", file: null });
    } catch (error) {
      console.error(error);
      setStatus("Failed to send message. Please try again.");
    }
  };

  return (
    <div id="contact-us" className="contact-us-container">
      <h2>Contact our team</h2>
      {status && <p className="status-msg">{status}</p>}

      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-group-row">
          <div className="form-group">
            <label>First name</label>
            <input
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              placeholder="First name"
              required
            />
          </div>
          <div className="form-group">
            <label>Last name</label>
            <input
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              placeholder="Last name"
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="your@mail.com"
            required
          />
        </div>

        <div className="form-group">
          <label>Phone number</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="98745 56321"
            required
          />
        </div>

        <div className="form-group">
          <label>Message</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Leave us a message..."
            required
          />
        </div>

        <div className="form-group">
          <label>Attach file (optional)</label>
          <input
            type="file"
            name="file"
            className="file-input"
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="submit-btn">
          Send message
        </button>
      </form>
    </div>
  );
};

export default ContactUs;